import * as PIXI from "pixi.js";
import { hexToNumber } from "./color";
import type { CoreComponent } from "../engines/coreComponents/coreComponents.types";
import { appState } from "./store";

// For now we are keeping this in utilities, but this should reside in CoreComponent.

// common hover filter that can be used across all Box components.
const hoverFilter = new PIXI.ColorMatrixFilter();

/**
 * Adds filter to the pixiComponent.
 * @param pixiComponent
 * @param color
 */
export const addFilter = (
  pixiComponent: CoreComponent["pixiComponent"],
  color: string
) => {
  pixiComponent.filters = [hoverFilter];
  hoverFilter.tint(hexToNumber(color));
  hoverFilter.resolution = appState.resolution;
};

/**
 * Removes the filter from the pixiComponent and releases the memory.
 * @param pixiComponent
 */
export const removeFilter = (pixiComponent: CoreComponent["pixiComponent"]) => {
  pixiComponent.filters = null;
};
